import { useUserPropertyAsObject } from '../user-property-object/index.tsx';

const BLUEPRINTS_TOUR_SPOTLIGHTS = 'polaris.blueprints.tour.spotlights';

type BlueprintsTourState = {
	tourDismissed: boolean;
	tourSpotlightStep: string;
};

export const useHasUserEngagedWithBlueprints = (): boolean => {
	const blueprintsTourState = useUserPropertyAsObject<BlueprintsTourState>(
		BLUEPRINTS_TOUR_SPOTLIGHTS,
	);

	return blueprintsTourState?.tourDismissed === true;
};
